/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import * as fromStore from 'app/shared/store';

@Injectable()
export class PublicPageGuard implements CanDeactivate<any> {
  constructor(private store: Store<fromStore.SharedState>) {}

  canDeactivate(
    _component: any,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ) {
    // The user should be able to navigate to the following:
    // - a new video
    // - the login page
    // - the register page
    // - the channel details page
    // - the athlete profile page
    // Other than that check if the user is logged in and only then allow navigation
    if (nextState.url === '/404' || nextState.url === '/' || nextState.url.includes('/public/')) {
      return true;
    }
    return this.checkStore();
  }

  checkStore(): Observable<any> {
    return this.store.select(fromStore.getUser).pipe(map(userData => userData && userData.id > 0));
  }
}
